import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=4cbacba7&scoped=true"
import script from "./Sorter.vue?vue&type=script&lang=js"
export * from "./Sorter.vue?vue&type=script&lang=js"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=4cbacba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbacba7",
  null
  
)

export default component.exports